///配置全局url
import Vue from 'vue'
import config from '@/config'
let host = config.apiHost
Vue.prototype.$apiUrl = {
    //登陆
    loginUrl: host + '/member/login',
    getResources: host + '/member/getResources',
    reSessionUrl: host + "/member/refSession",
    // 退出登录
    logoutUrl: host + '/member/safeLogout',
    //二维码管理
    scandataUrl: host + '/scandata/scanning_data',
    qrcodeTypeUrl : host + '/qrcode/qr_type',
    scandataListUrl : host + '/scandata/list',
    qrcodeStyleUrl : host + '/qrcode/qr_style',
    exportUrl : host + '/scandata/export',
    getqrcodeListUrl : host + '/qrcode/list',
    getqrcodestatusListUrl : host + '/qrcode/qr_status',
    getqrcodeImgUrl : host + '/qrcode/get_qr',
    qrcodeDelteUrl : host + '/qrcode/del',
    shopSearchUrl : host + '/xeshop/index',
    sysreferUrl : host + '/qrcode/sys_source',
    functionPageUrl : host + '/qrcode/function_page',
    getactiveListUrl : host + '/qrcode/get_actives',
    getqrIsforeverUrl : host + '/qrcode/qr_forever',
    getClassUrl : host + '/backclassify/getChildren',
    postFormUrl : host + '/qrcode/save',
    getDetailUrl : host + '/qrcode/detail',
    downLoadImgUrl : host + '/qrcode/imageout',
    goodsImport: host + '/goodsImport',

    // 活动管理
    getBusinessTypes: host + '/Businesstype/all_type',  // 业态选择
    getActiveTypes: host + '/activepage/active_type',   // 活动类型
    getShopList: host + '/xeshop/index',                // 店铺列表
    getAuthShopList: host + '/xeshop/getAuthShop',      // 用户权限内店铺列表
    getActivePageList: host + '/activepage/list',       // 活动列表
    addActivePage: host + '/activepage/add',            // 新增页面活动
    updateActivePage: host + '/activepage/update',      // 更新页面活动
    copyActivePage: host + '/activepage/copy_page',     // 复制页面活动
    deleteActivePage: host + '/activepage/del',         // 删除页面活动
    getActivePageDetail: host + '/activepage/detail',   // 活动页面详细
    getCouponList: host + '/coupon/define_list',        // 优惠券列表
    getProductsList: host +'/product/product_groupbybn',// 商品列表+搜索
    getWidgetData: host + '/activepage/get_widget_data',// 获取挂件数据
    releaseActivePage: host + '/activepage/release',    // 活动发布
    uploadImage: host + '/image/upload',                // 图片上传
    uploadPosterImage: host + '/image/upload',                // 海报上传
    downTemplate: host + '/product/dowload_pro_exceltemp',// 下载商品模版
    goodsTemplate: host + '/product/parse_excelpro',    //导入商品
    getGoodsInfo: host + '/product/products_info',      //获取商品图片
    getActiveLink: host + '/activepage/get_link',       // 查看活动链接
    getActiveQrcode: host + '/activepage/qr_code',      // 查看活动二维码
    refreshList: host + '/Activepage/listRelease',      // 刷新全部页面
    deleteAll: host + '/Activepage/delall',      // 批量删除
    editGame: host + '/screen/edit_game',      // 互动游戏添加
    gameList: host + '/screen/list',      // 互动游戏列表
    gameDetail: host + '/screen/get_game',      // 互动游戏详情
    gameStatus: host + '/screen/shelf',      // 互动游戏上下架
    // 内容管理
    getChannels: host + '/channel/list',  // 获取渠道
    updateConfiguration: host + '/content/changeItemAttr',  // 首页数据配置-更改配置项属性(可批量)
    saveContent: host + '/content/saveItem',  // 首页数据配置-保存配置项
    getCfgDetail: host + '/content/getAjaxItem',  // 首页数据配置-获取配置项详情
    updateItemAttr: host + '/BusinessConf/changeItemAttr'  // 商圈配置-修改属性

}



// WEBPACK FOOTER //
// ./src/assets/js/api-url.js